import { Bell } from 'lucide-react';

/**
 * Opens the reminders panel.
 *
 * The label collapses to an icon-only circular control on phones, which is why
 * the accessible name is carried by `aria-label` rather than by the visible text.
 *
 * @param {{onOpen: () => void}} props
 */
export function RemindersButton({ onOpen }) {
  return (
    <button
      type="button"
      className="btn reminders-btn"
      onClick={onOpen}
      aria-label="Reminders"
    >
      <Bell size={14} aria-hidden="true" />
      <span className="reminders-btn__label">Reminders</span>
    </button>
  );
}
